class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    document.addEventListener("DOMContentLoaded", () => {
      const miniCart = document.querySelector(".cart-drawer");

      if (miniCart) {
        const observerConfig = {
          childList: true,
          subtree: true
        };

        const observerCallback = (mutations, observer) => {
          for (const mutation of mutations) {
            if (mutation.addedNodes.length > 0) {
              this.addFreeGiftButtonEventListener();
            }
          }
        };

        const observer = new MutationObserver(observerCallback);
        observer.observe(miniCart, observerConfig);
      }
    });
  }

  addFreeGiftButtonEventListener() {
    const freeGiftButtons = document.querySelectorAll(".free-gift-button");

    freeGiftButtons.forEach(freeGiftButton => {
      if (!freeGiftButton.dataset.listenerAdded) {
        const handleClick = (event) => {
          event.preventDefault();

          const buttonId = freeGiftButton.dataset.buttonId;
          const isMobile = window.innerWidth <= 750;
          const cartFreeGiftSliders = document.querySelectorAll(`.cart-free-gift-slider`);

          cartFreeGiftSliders.forEach(slider => {
            const isMobileSlider = slider.classList.contains("cart-free-gift-mobile-slider");
            const isDesktopSlider = slider.classList.contains("cart-free-gift-desktop-popup");

            if (isMobile && isMobileSlider && slider.dataset.popupId === buttonId) {
              // Show the mobile slider associated with the clicked button on mobile devices
              slider.classList.remove("is-hidden");
            } else if (!isMobile && isDesktopSlider && slider.dataset.popupId === buttonId) {
              // Show the desktop slider associated with the clicked button on desktop devices
              slider.classList.remove("is-hidden");
            } else {
              // Hide all other sliders
              slider.classList.add("is-hidden");
            }
          });

          freeGiftButton.style.display = "none";
        };

        freeGiftButton.addEventListener("click", handleClick);
        freeGiftButton.dataset.listenerAdded = true;
      }
    });
  }

  updateMinusButtonStatus() {
    const quantityInputs = this.querySelectorAll('.quantity__input');
    const minusButtons = this.querySelectorAll('.quantity__button-minus');
    const plusButtons = this.querySelectorAll('.quantity__button-plus');

    for (let i = 0; i < quantityInputs.length; i++) {
      const input = quantityInputs[i];
      const minusButton = minusButtons[i];
      if (minusButton) {
        if (parseInt(input.value) <= 1) {
          minusButton.setAttribute('disabled', 'disabled');
        } else {
          minusButton.removeAttribute('disabled');
        }
      }
    }

    const updateButtonStatus = (button, action) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          this.updateMinusButtonStatus();
        }, 50);
      });
    };

    for (let i = 0; i < minusButtons.length; i++) {
      updateButtonStatus(minusButtons[i], 'minus');
      updateButtonStatus(plusButtons[i], 'plus');
    }
  }

  addPlusButtonEventListeners() {
    const plusButtons = this.querySelectorAll('.quantity__button-plus');
    plusButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          this.updateMinusButtonStatus();
        }, 50);
      });
    });
  }

  addMinusButtonEventListeners() {
    const minusButtons = this.querySelectorAll('.quantity__button-minus');
    minusButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          this.updateMinusButtonStatus();
        }, 50);
      });
    });
  }

  updateCart() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        this.updateMinusButtonStatus();
        this.addPlusButtonEventListeners();
        this.addMinusButtonEventListeners();

        const miniCartElement = document.getElementById('mini-cart');
        const mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              this.updateMinusButtonStatus();
              this.addPlusButtonEventListeners();
              this.addMinusButtonEventListeners();
            }
          });
        });

        mutationObserver.observe(miniCartElement, { childList: true, subtree: true });
        
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    })
    .catch(e => {
      console.error(e);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.updateCart();
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

document.addEventListener('DOMContentLoaded', function() {
  function showOverlay(productHandle, isMobile, isDesktop, isFreeSample, isDefault) {
    const selectButtons = document.querySelectorAll('.product-button[data-product-handle="' + productHandle + '"] .select-button');
    selectButtons.forEach(function(button) {
      button.style.display = 'none';
    });

    let overlayId = 'overlay-' + productHandle;
    if (isFreeSample) {
      overlayId += '-freesample';
    } else if (isDefault) {
      overlayId += '-default';
    } else if (isMobile) {
      overlayId += '-mobile';
    } else if (isDesktop) {
      overlayId += '-desktop';
    }
    const overlay = document.getElementById(overlayId);
    if (overlay) {
      overlay.style.display = 'block';
    } else {
      console.error('Overlay not found for product handle:', productHandle);
    }
  } 

  function fetchProductData(productHandle) {
    return fetch('/products/' + productHandle + '.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        return data.product;
      });
  }

  function isMobile() {
    return window.matchMedia("only screen and (max-width: 749px)").matches;
  }

  async function getSelectedVariantId(productHandle, variants) {
    let overlayId;
    let selectButton = document.querySelector('.select-button[data-product-handle="' + productHandle + '"][data-default], .select-button[data-product-handle="' + productHandle + '"][data-freesample], .select-button[data-product-handle="' + productHandle + '"][data-desktop]');
    let freeGiftButton = document.querySelector('.free-gift-button');
    if (freeGiftButton) {
      freeGiftButton.addEventListener('click', function() {
          if (isMobile()) {
              selectButton = document.querySelector('.select-button[data-product-handle="' + productHandle + '"][data-mobile]');
          }
      });
    }
    if (selectButton.hasAttribute('data-freesample')) {
        overlayId = '#overlay-' + productHandle + '-freesample';
    } else if (selectButton.hasAttribute('data-default')) {
        overlayId = '#overlay-' + productHandle + '-default';
    } else {
        overlayId = isMobile() ? '#overlay-' + productHandle + '-mobile' : '#overlay-' + productHandle + '-desktop';
    }
    const overlay = document.querySelector(overlayId);
    if (!overlay) {
      console.error('Overlay not found for product handle:', productHandle);
      return null;
    }

    const productOptionElements = overlay.querySelectorAll('select');
    const selectedOptions = Array.from(productOptionElements).map(select => select.value);
    const selectedVariant = variants.find(variant => {
      for (let i = 0; i < selectedOptions.length; i++) {
        const optionProperty = 'option' + (i + 1);
        if (!variant.hasOwnProperty(optionProperty)) {
          console.error(`Variant does not have property ${optionProperty}:`, variant);
          return false;
        }
        if (variant[optionProperty] !== selectedOptions[i]) {
          return false;
        }
      }
      return true;
    });
    if (!selectedVariant) {
      console.error('No variant found for selected options:', selectedOptions);
      return null;
    }
    return selectedVariant.id;
  }

  function addVariantToCart(productHandle, variantId, promoProductHandle) {
    fetchProductData(productHandle)
      .then(product => {
        if (product) {
          const data = {
            id: variantId,
            quantity: 1
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              const miniCart = document.querySelector('mini-cart');
              if (miniCart) {
                miniCart.updateCart();
              }
            })
            .catch(error => {
              console.error('Error adding variant to cart:', error);
            });
        } else {
          console.error('No product found with handle:', productHandle);
        }
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
      });
  }

  document.addEventListener('click', function(event) {
    let target = event.target;
    
    while (target && !target.matches('.select-button')) {
      target = target.parentElement;
    }

    if (target) {
      const productHandle = target.getAttribute('data-product-handle');
      if (target.hasAttribute('data-overlay')) {
        const isFreeSample = target.hasAttribute('data-freesample');
        const isDefault = target.hasAttribute('data-default');
        const isMobile = target.hasAttribute('data-mobile');
        const isDesktop = target.hasAttribute('data-desktop');
        showOverlay(productHandle, isMobile, isDesktop, isFreeSample, isDefault);
      }
    }
  });

  document.addEventListener('click', async function(event) {
    let target = event.target;

    while (target && !target.matches('.add-free-gift-button')) {
      target = target.parentElement;
    }

    if (target) {
      const productHandle = target.getAttribute('data-product-handle');
      const promoProductHandle = target.getAttribute('data-promo-product-handle');
      fetchProductData(productHandle).then(async product => {
        const variantId = await getSelectedVariantId(productHandle, product.variants);
        if (variantId) {
          addVariantToCart(productHandle, variantId, promoProductHandle);
        } else {
          console.error('No variant ID found. Cannot add to cart.');
        }
      });
    }
  });
});